import { render, staticRenderFns } from "./Module.vue?vue&type=template&id=364657fe&scoped=true"
import script from "./Module.vue?vue&type=script&lang=js"
export * from "./Module.vue?vue&type=script&lang=js"
import style0 from "./Module.vue?vue&type=style&index=0&id=364657fe&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364657fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('364657fe')) {
      api.createRecord('364657fe', component.options)
    } else {
      api.reload('364657fe', component.options)
    }
    module.hot.accept("./Module.vue?vue&type=template&id=364657fe&scoped=true", function () {
      api.rerender('364657fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/IntelligentInvestmentAssistant/components/Module.vue"
export default component.exports